import { captureException } from '@sentry/vue';

// Ensure that local storage is safe to use before proceeding
const getLocalStorageSafe = (): Storage | null => {
  try {
    const storage = window.localStorage;
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return storage;
  } catch (e) {
    // Ignore sentry reporting for type errors since they are expected on Android < 11.5
    if (!(e instanceof TypeError)) {
      captureException(e, { extra: { function: 'getLocalStorageSafe' } });
    }
    return null;
  }
};

export class LocalStorageHelper {
  localStorage = getLocalStorageSafe();

  isStorageAvailable(): boolean {
    return !!localStorage;
  }

  getItem(key: string): string | null {
    return this.localStorage?.getItem(key) || null;
  }

  setItem(key: string, item: string): boolean {
    let result = false;
    try {
      if (this.localStorage) {
        this.localStorage.setItem(key, item);
        result = true;
      }
    } catch (e) {
      captureException(e, { extra: { function: 'setItem', key: key, item: item } });
    }
    return result;
  }
}
